import React from 'react'
import DashboardMaster from '../../../../dashboard/DashboardMaster'
import AssetsContent from './AssetsContent'

const AdminAssets = () => {
    return (
        <DashboardMaster>
            <AssetsContent />
        </DashboardMaster>
    )
}

export default AdminAssets